export default __webpack_public_path__ + "static/media/cupomDescontoViacaoAmarelinho.c4adfca1.webp";